import React, { useState, useEffect, useContext } from 'react'
import { Link as RouterLink, useNavigate } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import * as Yup from 'yup'
import { Formik } from 'formik'
import { Box, Button, Container, Link, TextField, Typography } from '@material-ui/core'

// api
import { getPublicAPI } from '../api'

// utils
import Loader from '../components/utils/Loader'
// contexts
import { ToastContext } from '../contexts/Toast'

const ForgotPassword = () => {
   const navigate = useNavigate()

   const { setToasts } = useContext(ToastContext)
   const [loading, setLoading] = useState(true)

   useEffect(() => {
      let mounted = true

      setTimeout(() => {
         if (localStorage.auth_token) navigate('/app/dashboard')
         mounted && setLoading(false)
      }, 1000)

      return () => (mounted = false)
   }, [navigate])

   const onSubmit = async values => {
      try {
         let resetPass = await getPublicAPI('/forgot-password', values)

         // console.log(resetPass)
         if (resetPass?.success) {
            setToasts({
               type: 'success',
               messages: [{ msg: `Reset link sent to the email ${values.email}` }]
            })

            values.email = ''
         } else
            setToasts({
               type: 'error',
               messages: resetPass?.errors
            })
      } catch (err) {
         setToasts({
            type: 'error',
            messages: [{ msg: `error in resetting password in ${err.message}` }]
         })
      }
   }

   return (
      <>
         <Helmet>
            <title>{loading ? 'Loading...' : 'Forgot password | The HosePod'}</title>
         </Helmet>
         <Box
            sx={{
               backgroundColor: 'background.default',
               display: 'flex',
               flexDirection: 'column',
               height: '100%',
               justifyContent: 'center'
            }}
         >
            <Container maxWidth='sm'>
               {loading ? (
                  <Loader />
               ) : (
                  <Formik
                     initialValues={{
                        email: 'manish.kumar@kayosys.com'
                     }}
                     validationSchema={Yup.object().shape({
                        email: Yup.string()
                           .email('Must be a valid email')
                           .max(255)
                           .required('Email is required')
                     })}
                     onSubmit={onSubmit}
                  >
                     {({
                        errors,
                        handleBlur,
                        handleChange,
                        handleSubmit,
                        isSubmitting,
                        touched,
                        values
                     }) => (
                        <form onSubmit={handleSubmit}>
                           <Box sx={{ mb: 3 }}>
                              <Typography color='textPrimary' variant='h2'>
                                 Reset password
                              </Typography>
                              <Typography color='textSecondary' gutterBottom variant='body2'>
                                 Reset password of your account
                              </Typography>
                           </Box>
                           <TextField
                              error={Boolean(touched.email && errors.email)}
                              fullWidth
                              helperText={touched.email && errors.email}
                              label='Email Address'
                              margin='normal'
                              name='email'
                              onBlur={handleBlur}
                              onChange={handleChange}
                              type='email'
                              value={values.email}
                              variant='outlined'
                           />
                           <Box sx={{ py: 2 }}>
                              <Button
                                 color='primary'
                                 disabled={isSubmitting}
                                 fullWidth
                                 size='large'
                                 type='submit'
                                 variant='contained'
                              >
                                 Reset password
                              </Button>
                           </Box>
                           <Typography color='textSecondary' variant='body1'>
                              Have an account?{' '}
                              <Link component={RouterLink} to='/login' variant='h6'>
                                 Login
                              </Link>
                           </Typography>
                           <Typography color='textSecondary' variant='body1'>
                              Don&apos;t have an account?{' '}
                              <Link component={RouterLink} to='/register' variant='h6'>
                                 Sign up
                              </Link>
                           </Typography>
                        </form>
                     )}
                  </Formik>
               )}
            </Container>
         </Box>
      </>
   )
}

export default ForgotPassword
